<template>
  <div>
    <h1>Create new document</h1>
    <FileWorking :file="file" />
    <v-alert :value="addressbookTypes" type="info">Choose entity type</v-alert>
    <v-alert
      :value="!addressbookTypes"
      type="warning"
    >There are no related templates. This means there are no templates related to relevant entity types for this file category or department.</v-alert>
    <div v-for="addressbookType in addressbookTypes" :key="addressbookType.type.entityTypeId">
      <v-btn @click="navigate(addressbookType.type.entityTypeId)">{{addressbookType.type.name}}</v-btn>
    </div>
  </div>
</template>

<script>
import FileWorking from "@/components/link/FileWorking";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "DocumentEntityType",
  metaInfo() {
    return {
      title: "Document entity type",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    FileWorking
  },
  data() {
    return {
      file: null,
      addressbook: null,
      addressbookTypes: null
    };
  },
  methods: {
    fetchFile() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.$route.params.objectId}`)
        .then(response => {
          // console.log(response.data);
          this.file = response.data;
        });
    },
    fetchAddressbook() {
      nbmlaw
        .get(
          `/cors/admin/file/files/${this.$route.params.objectId}/addressbook`
        )
        .then(response => {
          // console.log(response.data);
          this.addressbook = response.data;
        });
    },
    navigate(entityTypeId) {
      this.$router.push({
        name: "documentEntity",
        params: {
          objectType: this.$route.params.objectType,
          objectId: this.$route.params.objectId,
          entityTypeId
        }
      });
    }
  },
  watch: {
    addressbook() {
      if (this.addressbook) {
        // console.log(this.addressbook);
        this.addressbookTypes = this.addressbook.addressbookTypes
          .filter(addressbookType => addressbookType.write)
          .map(addressbookType => {
            return {
              type: addressbookType.type
            };
          });
        // console.log(this.addressbookTypes);
      } else {
        this.addressbookTypes = null;
      }
    }
  },
  created() {
    this.fetchAddressbook();
    this.fetchFile();
  }
};
</script>
